const DirectExpenseIcon = () => {
  return (
    <svg viewBox="0 0 13.757 30">
      <g transform="translate(-138.836 -10.074)">
        <path d="M145.714,10.074l-6.682,6.416a.623.623,0,0,0,.256,1.052.614.614,0,0,0,.608-.154l5.193-4.983V39.441a.625.625,0,1,0,1.25,0V12.406l5.193,4.983a.614.614,0,0,0,.608.154.623.623,0,0,0,.256-1.052Z" />
      </g>
    </svg>
  );
};

export default DirectExpenseIcon;
